<template>
    <div class="container">
        <div class="search">
            <form action="/">
                <van-search v-model="title" shape="round" background="#F2F2F2" placeholder="请输入项目名称" @search="onSearch">
                    <template #right-icon>
                        <van-button @click.prevent.stop="onSearch(title)" color="#2553E2" size="mini" round
                            type="info">搜索</van-button>
                    </template>
                    <template #action>
                        <van-icon class="addBtn" name="add-o" @click="toEdit()" />
                    </template>
                </van-search>
            </form>
        </div>

        <div class="projectList">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" finished-text="暂无更多数据" @load="onLoad">
                    <!-- <van-cell v-for="item, index in list" :key="index" :title="item.title" /> -->
                    <div class="card" v-for="item, index in list" :key="index">

                        <van-row class="title">
                            <van-col span="12" class="name">
                                <img src="@/assets/images/myactive.png" alt="" />
                                <span>{{ item.title }}</span>
                            </van-col>
                            <van-col span="12" class="date">
                                {{ item.createTime }}
                            </van-col>
                        </van-row>

                        <van-row class="content">
                            <van-col span="6" class="img">
                                <img @click="download(item)" :id="'qrcode' + index" :src="item.qrcodeUrl" alt="" />
                            </van-col>
                            <van-col span="9" class="info">
                                <p>项目编号：{{ item.numbers }}</p>
                                <p>专家单人费：{{ item.expertsPrice }}</p>
                            </van-col>
                            <van-col span="9" class="info right">
                                <p>专家数：{{ item.expertsNum }}</p>
                                <p>总费用：{{ Number(item.expertsNum) * Number(item.expertsPrice) }}</p>
                            </van-col>
                        </van-row>

                        <van-row class="btns">
                            <van-button round plain type="default" @click="deleteProject(item)">删除</van-button>
                            <van-button color="#2553E2 " round plain type="primary"
                                @click="selectUsers(item)">指定专家</van-button>
                            <van-button color="#2553E2 " round plain type="primary"
                                @click="toEdit(item)">修改</van-button>
                            <van-button color="#2553E2 " round plain type="primary"
                                @click="download(item, 1)">下载</van-button>
                        </van-row>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>

        <div class="actionBtns">
            <van-button color="#2553E2" round type="primary" @click="toEdit()">添加项目</van-button>
            <van-button color="#2553E2" round type="primary" @click="goOut()">退出登录</van-button>
        </div>

        <van-overlay :show="isShow" z-index="999" @click="isShow = false">
            <div class="showdowncode"> </div>
        </van-overlay>

        <van-popup v-model="showUserSelect" position="bottom" class="userSelect">
            <div class="van-picker__toolbar">
                <button type="button" class="van-picker__cancel" @click="cancel">取消</button>
                <!-- <div class="van-ellipsis van-picker__title">
                    <span>(最多选1个)</span>
                </div> -->
                <button type="button" class="van-picker__confirm" @click="onConfirm">确认</button>
            </div>

            <div class="checkbox-container">
                <van-field v-model="searchVal" placeholder="搜索专家" @input="searchUser" clearable />
                <van-checkbox-group v-model="expertIds" ref="checkboxGroup">
                    <van-cell-group>
                        <van-cell v-for="(item, index) in userOptions" clickable :key="index" :title="item.name"
                            @click="toggle(item)">
                            <template #right-icon>
                                <van-checkbox :name="item.id" shape="square" ref="checkUser" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </div>
        </van-popup>


    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { pageProjects, removeProject, pageUsers, assignUserApi } from '@/api/projectList'
import { removeToken } from '@/utils/token-util';

export default {
    data() {
        return {
            title: null,
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            limit: 10,
            isShow: false,
            showUserSelect: false,
            userList: [],
            userOptions: [],
            expertIds: [],
            searchVal: null,
            current: null
        };
    },
    methods: {
        onSearch(val) {
            this.title = val;
            this.page = 1;
            this.finished = false;
            this.list = [];
            this.loading = true;
            this.getProjectList();
        },
        getProjectList() {
            pageProjects({
                page: this.page,
                limit: this.limit,
                title: this.title
            }).then(res => {
                if (this.refreshing) {
                    this.list = res.list;
                    this.refreshing = false;
                } else {
                    this.list = this.list.concat(res.list);
                }
                if (res.list.length < this.limit) {
                    this.finished = true;
                }
            }).catch(err => {
                console.log(err);
                Toast.fail('获取项目列表失败');
            }).finally(() => {
                this.loading = false;
            });
        },
        onLoad() {
            if (this.finished) return;
            this.loading = true;
            this.page++;
            this.getProjectList();
        },
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.page = 1;
            this.list = [];
            this.getProjectList();
        },
        toEdit(row) {
            let obj = {
                path: '/projectlist/edit',
                query: {}
            }
            if (row) {
                obj.query.id = row.id
            }
            this.$router.push(obj);
        },

        download(row, type) {
            let img = document.createElement("img")
            img.src = row.qrcodeUrl
            img.style.width = '100%'
            let showdowncode = document.querySelector(".showdowncode")
            showdowncode.innerHTML = "";
            showdowncode.appendChild(img)
            this.isShow = true

            if (type) {
                Toast.success('请长按图片进行保存');
            }
        },
        deleteProject(row) {
            Dialog.confirm({
                title: '提示',
                message: '请确认是否删除所选数据',
                cancelButtonText: '关闭',
                cancelButtonColor: '#fff',
                confirmButtonColor: '#2553E2',
                theme: 'round-button',
            })
                .then(() => {
                    removeProject(row.id).then(res => {
                        Toast.success(res);
                        this.onRefresh();
                    }).catch(err => {
                        console.log(err);
                        Toast.fail(err.message);
                    });
                })
                .catch(() => {
                    // on cancel
                });
        },
        goOut() {
            Dialog.confirm({
                title: '提示',
                message: '请确认是否退出当前帐号',
                cancelButtonText: '关闭',
                cancelButtonColor: '#fff',
                confirmButtonColor: '#2553E2',
                theme: 'round-button',
            })
                .then(() => {
                    removeToken();
                    this.$router.push({
                        path: "/login"
                    })
                })
                .catch(() => {
                    // on cancel
                });
        },
        getUsers() {
            pageUsers({
                page: 1,
                limit: 9999
            }).then((res) => {
                this.userList = res.list
            }).catch((e) => {
                console.log(e)
            })
        },
        selectUsers(item) {
            this.current = item
            this.expertIds = item.expertsList.map(e => e.expertId)
            this.showUserSelect = true
        },
        cancel() {
            this.current = null
            this.showUserSelect = !this.showUserSelect
            this.expertIds = []
        },
        onConfirm() {
            Dialog.confirm({
                title: '提示',
                message: '请确认是否保存指定专家',
                cancelButtonText: '取消',
                cancelButtonColor: '#fff',
                confirmButtonColor: '#2553E2',
                theme: 'round-button',
            })
                .then(() => {
                    let obj = {
                        id: this.current.id,
                        expertIds: this.expertIds
                    }
                    assignUserApi(obj).then(res => {
                        Toast.success(res);
                        this.cancel()
                        this.onSearch()
                    }).catch((e) => {
                        Toast.fail(e.message)
                    })
                })
                .catch(() => {
                    // on cancel
                });
        },
        searchUser(value) {
            if (value) {
                this.userOptions = this.userList.filter(item => item.name.includes(value))
            } else {
                this.userOptions = this.userList
            }
        },
        toggle(item) {
            if (this.expertIds.includes(item.id)) {
                this.expertIds = this.expertIds.filter(val => val != item.id);
            } else {
                this.expertIds.push(item.id);
            }
        },
    },
    created() {
        this.getProjectList();
        this.getUsers()
    }
};
</script>
<style lang="scss" scoped>
.container {
    background-color: #F2F2F2;
    padding-top: 6px;

    .search {
        :deep(.van-search__content) {
            background-color: #fff;

            .van-field__left-icon {
                display: flex;
                align-items: center;
            }

            .van-field__right-icon {
                display: flex;
                align-items: center;

                .van-button {
                    padding: 15px 20px;
                    font-size: 14px;
                }
            }
        }

        .van-search__action {
            padding: 0 10px;
        }

        .addBtn {
            font-size: 28px;
            color: #2553e2;
            display: flex;
            align-items: center;
            font-weight: bold;
        }
    }

    .projectList {
        padding: 0 10px 60px 10px;
        min-height: calc(100vh - 68px);

        .van-pull-refresh {

            .card {
                background-color: #fff;
                border-radius: 6px;
                padding: 20px 10px 20px 20px;
                font-size: 14px;
                margin-top: 10px;

                .title {
                    .name {
                        font-size: 16px;
                        font-weight: bold;
                        text-align: left;

                        img {
                            width: 24px;
                            height: 20px;
                            margin-right: 10px;
                        }
                    }

                    .date {
                        text-align: right;
                        padding-top: 3px;
                    }
                }

                .content {
                    text-align: left;
                    margin-top: 10px;

                    .img {
                        padding-right: 6px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .info {
                        padding: 10px 0;

                        p {
                            margin-top: 6px;
                        }
                    }

                    .right {
                        text-align: right;
                    }
                }

                .btns {
                    text-align: right;
                    margin-top: 6px;

                    .van-button {
                        padding: 10px 15px;
                        height: 32px;
                        margin-left: 8px;
                    }
                }
            }
        }
    }

    .actionBtns {
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 0 10px 24px 10px;

        .van-button {
            width: 45%;

            &:last-child {
                margin-left: 10px;
            }
        }
    }

    .showdowncode {
        height: 100%;
        display: flex;
        align-items: center;
    }

    .userSelect {
        border-radius: 20px 20px 0 0;

        .van-picker__confirm {
            color: #2553e2;
        }

        .checkbox-container {
            height: 300px;
            overflow-y: auto;

            .van-cell {
                padding: 10px 30px;

                &::after {
                    width: 100%;
                    left: 0;
                }
            }

            .van-cell__title {
                text-align: left;
            }

            :deep(.van-checkbox__icon--checked) {
                .van-icon {
                    background-color: #2553e2;
                    border-color: #2553e2;
                }
            }
        }
    }

}
</style>